import { useQuery } from "@tanstack/react-query";
import { fetchPromotionalCodeDetails } from "../api/fetchPromotionalCodeDetails";

export const usePromotionalCodeDetails = (id, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["promotionalCodeDetails", id],
    queryFn: () => fetchPromotionalCodeDetails(id),
    enabled: enabled && !!id,
  });

  return {
    data: data?.result || null,
    code: data?.result?.code || data?.result || null,
    error,
    isLoading,
    refetch,
  };
};

